var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGarage = function SvgGarage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.508 2.19a1.25 1.25 0 0 0-1.016 0l-15 6.667a1.25 1.25 0 1 0 1.016 2.285L20 4.7l14.492 6.44a1.25 1.25 0 1 0 1.016-2.284z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.173 14.536a1.25 1.25 0 0 1 1.16-.786h15c.38 0 .74.173.976.47l6.292 7.863h1.066a4.583 4.583 0 0 1 4.583 4.584v6.666c0 .69-.56 1.25-1.25 1.25h-2.257a4.58 4.58 0 0 1-4.41 3.334 4.58 4.58 0 0 1-4.41-3.334h-7.847a4.582 4.582 0 0 1-8.819 0H5c-.69 0-1.25-.56-1.25-1.25v-10q0-.24.09-.464zM33.75 32.083h-1.007a4.582 4.582 0 0 0-8.82 0h-7.847a4.583 4.583 0 0 0-8.819 0H6.25v-7.5h25.417a2.083 2.083 0 0 1 2.083 2.084zm-24.167 1.25v.006a2.083 2.083 0 1 0 0-.011zm-2.737-11.25H18.75V16.25H9.18zM21.25 16.25v5.833h6.15l-4.667-5.833zm5.61 15.61a2.083 2.083 0 1 1 2.946 2.946 2.083 2.083 0 0 1-2.946-2.946",
    clipRule: "evenodd"
  })));
};
export default SvgGarage;